import { useParams } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Trophy, Plus } from "lucide-react";
import { useTeamLeaderboard } from "./team/useTeamLeaderboard";
import { gridClass, placeholderCount } from "./team/leaderboardModel";
import { MemberCard, PlaceholderCard } from "./team/MemberCard";
import { AddMemberDialog, EditPhotoDialog, DeleteMemberDialog } from "./team/TeamDialogs";

const TeamLeaderboard = () => {
  const { userId } = useParams();
  const t = useTeamLeaderboard(userId);

  return (
    <Card className="glass-card card-3d holo-border p-6 overflow-visible relative" data-testid="team-leaderboard">
      <div className="mb-6 relative z-10">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-2xl text-white flex items-center gap-3"><Trophy className="h-6 w-6 text-ism-teal" /><span className="text-ism-teal">Team Leaderboard</span></h2>
            <p className="text-sm text-gray-400 mt-1">Points: Revenue ($1K = 100pts) + Deals (500pts) + Meetings (50pts) + Calls (10pts) + Emails (5pts)</p>
          </div>
          <Button onClick={() => t.setIsAddingMember(true)} className="bg-ism-teal hover:bg-ism-teal/90 text-black font-semibold" data-testid="add-member-btn">
            <Plus className="h-4 w-4 mr-2" /> Add Member
          </Button>
        </div>
      </div>

      <div className={`grid grid-cols-1 ${gridClass(t.members.length)} gap-4 relative z-10`}>
        {t.members.map((member, idx) => <MemberCard key={member.memberId} member={member} idx={idx} onDelete={t.setDeletingMember} onEditPhoto={t.setEditingMember} />)}
        {[...Array(placeholderCount(t.members.length))].map((_, i) => <PlaceholderCard key={`placeholder-${i}`} i={i} onAdd={() => t.setIsAddingMember(true)} />)}
      </div>

      <AddMemberDialog open={t.isAddingMember} onOpenChange={t.setIsAddingMember} member={t.newMember} setMember={t.setNewMember}
        photoPreview={t.photoPreview} setPhotoPreview={t.setPhotoPreview} onPhoto={t.handlePhotoUpload} onSubmit={t.handleAddMember} onCancel={t.resetAddForm} />
      <EditPhotoDialog memberId={t.editingMember} onClose={() => t.setEditingMember(null)} onPhoto={t.handlePhotoUpload} />
      <DeleteMemberDialog member={t.deletingMember} onClose={() => t.setDeletingMember(null)} onConfirm={t.handleDeleteMember} />
    </Card>
  );
};

export default TeamLeaderboard;
